import React from "react";
import { Box, Typography } from "@mui/material";
import Colors from "../assets/color";
import DownloadApp from "../components/DownloadApp";

const ChargingContent = () => {

  return (
    <Box sx={{
      width: '100%',
      backgroundColor: 'black',

    }}>

      <Box
        component='section'
        sx={{
          position: 'relative',
          height: 'calc(100vh)',
          maxWidth: '240rem',
          margin: '0 auto',
          maxHeight: '120rem',
          display: 'flex',
          justifyContent: 'center',
          flexDirection: { xs: 'column', md: 'row' },
          overflow: 'hidden',
          p: { xs: '2rem', sm: '2rem', md: '8rem' },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: 'column',
            justifyContent: 'center',
            py: { xs: '8rem', md: '14rem' },
            position: 'relative',
            width: '100%',
            px: { xs: '2rem', sm: '2rem', md: '6.4rem' },
          }}>

          <Box
            sx={{
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              width: 'fit-content',
              alignItems: 'center',
              justifyContent: 'center',
              textAlign: { xs: 'center', sm: 'left' },
            }}
          >

            <Typography
              sx={{
                color: "#fff",
                fontSize: { xs: '3rem', sm: '4rem', md: '4.5rem' },
                fontWeight: 700,
                lineHeight: { xs: '2.8rem', md: '5rem' },
                maxWidth: '22ch',
              }}
            >
              Charging shouldn’t be a guessing game.
            </Typography>

            <Typography
              sx={{
                color: "#FEFFFACC",
                fontSize: '1.8rem',
                fontWeight: 400,
                my: '4rem',
                maxWidth: '60ch',
              }}
            >
              80% of EV drivers struggle to find a reliable charger. Public infrastructure can’t keep up.
              SplitEV bridges the gap by transforming driveways, parking lots,
              and fleets into a single on-demand nationwide network.
              SplitEV ensures a charger is always ready whereever you drive and park.
            </Typography>
          </Box>

          <Box sx={{ width: 'fit-content', margin: { xs: '0 auto', sm: '0' } }}>
            <DownloadApp BTNtext={'See how SplitEV works'}></DownloadApp>
          </Box>

        </Box>

        <Box
          sx={{
            width: "100%",
            height: "100%",
            zIndex: 0,
            opacity: 1,
            backgroundImage: `url(${require('../assets/images/full_hand_holding_SplitEV.png')})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: {
              xs: 'top', sm: 'left', md: 'left', l: 'top'
            },
          }}
        ></Box>

      </Box >
    </Box >

  );
};

export default ChargingContent;
